module.exports = __webpack_public_path__ + "static/media/world.6f8c208a.svg";